import type { IconName } from "../components/Icon";

export interface Step {
  id: string;
  icon: IconName;
  title: string;
  description: string;
}

export const STEPS: Step[] = [
  { id: "request", icon: "mail", title: "Request access", description: "Tell us your name and email. It takes under a minute." },
  { id: "invite", icon: "check", title: "We invite you", description: "We read every request and email your invitation with everything you need to sign in." },
  { id: "start", icon: "family", title: "Set up your family", description: "Sign in, add your child, and build their first board together." },
];
